/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_LEAVE_DETAILS_SUCCESS,
  LOAD_LEAVE_DETAILS_ERROR,
  LOAD_LEAVE_PERMISSION_SUCCESS,
  LOAD_LEAVE_PERMISSION_ERROR,
  LOAD_LOP_SUCCESS,
  LOAD_LOP_ERROR,
  LOAD_DROPDOWN_LEAVE_SUCCESS,
  LOAD_DROPDOWN_LEAVE_ERROR,
  LOAD_SETTING_SUCCESS,
  LOAD_SETTING_ERROR
} from "./constants";

const initialState = {
  leaveList: [],
  permissionList: [],
  lopList: [],
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
  dropDownList: {},
  settingList:[]
};

const Reducer = (
  state = initialState,
  { type, leaveList, permissionList, lopList, dropDownList, error,settingList }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_LEAVE_DETAILS_SUCCESS:
        draft.leaveList = leaveList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_LEAVE_PERMISSION_SUCCESS:
        draft.permissionList = permissionList;
        draft.error = false;
        draft.success = false;
        break;
          case LOAD_SETTING_SUCCESS:
        draft.settingList = settingList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_LOP_SUCCESS:
        draft.lopList = lopList;
        draft.error = false;
        draft.success = false;
        break;   
      case LOAD_DROPDOWN_LEAVE_SUCCESS:
        draft.dropDownList = dropDownList;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_SETTING_ERROR:
      case LOAD_DROPDOWN_LEAVE_ERROR:
      case LOAD_LEAVE_DETAILS_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      case LOAD_LEAVE_PERMISSION_ERROR:
        draft.error = error;
        draft.success = false;
        break;
       case LOAD_LOP_ERROR:
        draft.error = error;
        draft.success = false;
        break;

      default:
        return state;
    }
  });
};

export default Reducer;
